import { useEffect, useReducer } from 'react';

/** Expiry belongs to the disclosure owner, even while all proposal cards are hidden. */
export function usePendingSuggestions(
  suggestions: readonly { id: string; status: string; expiresAt: string }[] | undefined,
) {
  const [tick, update] = useReducer((value: number) => value + 1, 0);
  const now = Date.now();
  const pending = (suggestions ?? []).filter((item) => item.status === 'pending' && Date.parse(item.expiresAt) > now);
  const nextExpiry = Math.min(...pending.map((item) => Date.parse(item.expiresAt)));
  useEffect(() => {
    if (!Number.isFinite(nextExpiry)) return;
    const timer = setTimeout(update, Math.min(2_147_483_647, Math.max(1, nextExpiry - Date.now())));
    return () => clearTimeout(timer);
  }, [nextExpiry, tick]);
  return pending
    .map((item) => item.id)
    .sort()
    .join(':');
}
